import { SelectedMenu } from 'rangeConfig/@types';
import { matchWidth, matchDepth } from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import {
  filterDesk,
  filterInteriorColors,
  filterInteriorDimensions
} from 'rangeConfig/billy/filters/selectedMenuProductFilters';
import deleteInterior from 'rangeConfig/billy/behaviours/deleteInterior';
import replaceInterior from 'rangeConfig/billy/behaviours/replaceInterior';
import { CoreApi } from '@inter-ikea-storageone/range';
import { DeskToggle } from 'rangeConfig/billy/widgets/DeskToggle/DeskToggle';
import checkWidget from 'rangeConfig/shared/widgets/checkWidget';
import { hideToggleDeskType } from 'rangeConfig/billy/rules/hideMenuRules';

const widgets = {
  desktop: [
    {
      id: 'interiors-selected-menu-interiors',
      title: 'storageone.productListInteriorsTitle',
      cardsSubtitle: 'typeName, designText',
      behaviors: {
        productClicked: [replaceInterior],
        productDropped: [replaceInterior]
      },
      productFilters: [filterInteriorDimensions, filterInteriorColors, filterDesk]
    },
    {
      id: 'change-desk-type',
      component: checkWidget(DeskToggle),
      title: 'storageone.billyDeskVariantTitle',
      hidden: (coreApi: CoreApi) => hideToggleDeskType(coreApi)
    }
  ],
  mobile: [
    {
      id: 'interiors-selected-menu-interiors',
      title: 'storageone.productListInteriorsTitle',
      cardsSubtitle: 'typeName, designText',
      behaviors: {
        productClicked: [replaceInterior],
        productDropped: [replaceInterior]
      },
      productFilters: [matchWidth, matchDepth, filterInteriorColors, filterDesk]
    },
    {
      id: 'change-desk-type',
      component: checkWidget(DeskToggle),
      title: 'storageone.billyDeskVariantTitle',
      hidden: (coreApi: CoreApi) => hideToggleDeskType(coreApi)
    }
  ]
};

const selectedMenu: SelectedMenu = {
  menuTitle: (coreApi: CoreApi) =>
    hideToggleDeskType(coreApi)
      ? 'storageone.selectedProductListCustomiseInterior'
      : 'storageone.selectedProductListCustomiseBillyDesk',
  behaviors: {
    productDeleted: [deleteInterior]
  },
  content: widgets[platform]
};

export default selectedMenu;
